import styled, { css } from 'styled-components';
import { DeprecatedGrid as Grid, buttonCSS } from '@simplywallst/ui-core';

import type { ButtonProps } from '@simplywallst/ui-core';

import { RouterLink as DefaultRouterLink } from '@redux-first-router-link';

export const ListItem = styled('li')`
  margin-top: 4px;
  &:first-child {
    margin-top: 0;
  }
`;

export const NoRisksWrapper = styled('div')`
  margin-top: -${({ theme }) => theme.x1spacePx}px;
`;

export const RisksAndRewards = styled(Grid)`
  overflow: hidden;
`;

export const RouterLink = styled(DefaultRouterLink)<ButtonProps>`
  ${buttonCSS}
  text-align: center;
  &:before {
    ${({ theme }) => css`
      background: linear-gradient(
        180deg,
        ${theme.color.charcoalRGBA(0)} 0%,
        ${theme.color.charcoalRGBA(0.6)} 50%,
        ${theme.color.charcoalRGBA(1)} 100%
      );
    `}
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: ${({ theme }) => theme.x8spacePx}px;
    top: -${({ theme }) => theme.x10spacePx}px;
    left: 0;
    pointer-events: none;
  }
`;
